import React from 'react';
import { RoughNotation } from 'react-rough-notation';
import { useNavigate } from 'react-router-dom';

const TitleBanner = ({ title, subheading, image }) => {
  const navigate = useNavigate();

  return (
    <div className="w-full min-h-[600px] overflow-hidden bg-[#336fb8] relative px-4 md:px-12 py-8 md:py-16 flex flex-col md:flex-row">
      {/* Left Content */}
      <div className="w-full md:w-[45%] pt-4 md:pt-8 px-4 md:px-12 z-10">
        <div className="relative">
          <div className="inline-block relative">
            <h1 className="text-white text-4xl md:text-6xl/[1.2] font-bold">{title}</h1>
            <div className="border-b-4 border-white w-1/2 mt-2"></div>
          </div>
        </div>

        <h2 className="text-white text-2xl md:text-[32px] leading-tight mt-4 md:mt-8 font-semibold">
          {subheading}
        </h2>

        <div className="flex flex-col md:flex-row gap-4 mt-8 md:mt-12">
          <button 
            className="bg-secondary-green font-bold text-white px-8 md:px-16 py-3 rounded-3xl text-base md:text-lg"
            onClick={() => navigate('/contact')}
          >
            Contact us
          </button>
          <button 
            className="bg-primary text-white font-bold px-8 md:px-16 py-3 rounded-3xl text-base md:text-lg"
            onClick={() => navigate('/properties')}
          >
            Vacancies
          </button>
        </div>
      </div>

      {/* Right Circles and Image Container */}
      <div className="absolute right-0 top-0 w-full md:w-[55%] h-full opacity-25 md:opacity-100 overflow-visible">
        {/* Yellow circle */}
        <div className="absolute top-0 right-0 w-48 md:w-64 h-48 md:h-64 rounded-full bg-primary-yellow
                      transform translate-x-12 -translate-y-4" />

        {/* White circle */}
        <div className="absolute bottom-0 right-80 w-48 md:w-64 h-48 md:h-64 rounded-full bg-white
                      transform translate-x-24 translate-y-12" />
        
        {/* Main primary circle */}
        <div className="absolute top-0 right-0 w-[400px] h-[400px] md:w-[450px] md:h-[450px] rounded-full bg-primary  
                      transform translate-x-8 md:translate-x-12 translate-y-8" />

        {/* Purple border circle */}
        <div className="absolute top-0 right-0 w-[420px] h-[420px] md:w-[470px] md:h-[470px] rounded-full 
                      transform translate-x-12 md:translate-x-16 translate-y-4
                      border-4 border-white" />

        {/* Image container with proper positioning - now larger */}
        <div className="absolute right-0 bottom-0 h-full w-full flex items-end justify-end">
          <img 
            src={image}
            alt="Title Banner"
            className="object-contain h-full max-w-full"
            style={{
              width: 'auto',
              maxWidth: '95%',
              maxHeight: '95%',
              objectPosition: 'right bottom'
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default TitleBanner;